export async function duplicateItem(type, key, forcedValue, opts) {
  if (!type || !key) {
    return this.error('Type or key is not defined for create operation')
  }

  const item = this.call(
    'deepClone',
    forcedValue?.value ? forcedValue : this.call('getItem', key, type)
  )

  if (!item) {
    this.call('openNotification', {
      type: 'error',
      title: this.call('polyglot', 'editor.crud.notFound.title'),
      message: this.call('polyglot', 'editor.crud.notFound.message')
        .replace('{key}', key)
        .replace('{type}', type)
    })
    return this.error('Could not find target element')
  }

  const altKey = this.call('findNewName', type, key)
  if (!altKey) {
    this.call('openNotification', {
      type: 'error',
      title: this.call('polyglot', 'editor.crud.duplicateFailed.title'),
      message: this.call('polyglot', 'editor.crud.duplicateFailed.message')
        .replace('{key}', key)
        .replace('{altKey}', altKey)
    })
    return this.error('Could not duplicate')
  }
  item.key = altKey

  if (this.call('hasArtboard', type)) {
    if (item.settings.gridOptions.y) {
      item.settings.gridOptions.y += 2
    }
  }

  await this.call('createItem', type, altKey, item, opts)

  this.testAll(`Duplicating ${key} as ${altKey} in ${type}`, () => [
    this.testCase(
      'Item exists in root state',
      'exists',
      this.getSchemaItem(altKey, type) && this.getDataItem(altKey, type)
    )
  ])

  return item
}
